export default __webpack_public_path__ + "static/media/img_introduce_ai_1.c95c0cc6.png";